import axios from "axios";

const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY || '';
const BASEURL = 'https://translation.googleapis.com/language/translate/v2';


async function detectLanguage(text) {

    const response = await axios.post(
        `${BASEURL}/detect?key=${apiKey}`,
        {
            q: text
        }
    );
    console.log(response)
    return response.data.data.detections[0][0].language;
}


async function translateText(text, targetLanguage) {
    if (text) {
        const sourceLanguage = await detectLanguage(text);

        const response = await axios.post(
            `${BASEURL}?key=${apiKey}`,
            {
                q: text,
                source: 'en',
                target: targetLanguage
            }
        );
        console.log(response)
        return response.data.data.translations[0].translatedText;
    }
}

const updateText = async (word, setTranslatedText) => {
    word = word.replaceAll(",", ";");
    word = word.replace(/[\s\S]{1,150}(?!\S)/g, '$&,')
    // console.log(word);
    axios
        .get(
            `https://www.google.com/inputtools/request?text=${encodeURIComponent(
                word
            )}&ime=transliteration_en_hi&num=5&cp=0&cs=0&ie=utf-8&oe=utf-8&app=jsapi&uv=samjhaye%3A%E0%A4%B8%E0%A4%AE%E0%A4%9D%E0%A4%BE%E0%A4%8F-0-1%3A%3B0%3B0&cb=_callbacks_._5lm4lrt5f`
        )
        .then((response) => {
            // Extract the transliterated text from the API response
            // console.log(response.data);
            // Remove the leading and trailing characters that are not part of JSON
            const startIndex = response.data.indexOf("[");
            const endIndex = response.data.lastIndexOf("]");
            const jsonStr = response.data.substring(startIndex, endIndex + 1);

            // Replace single quotes with double quotes to make it valid JSON
            const jsonWithDoubleQuotes = jsonStr.replace(/'/g, '"');

            // Parse the modified string into a JavaScript object
            const parsedJson = JSON.parse(jsonWithDoubleQuotes);
            // console.log(parsedJson?.[1]?.[0]?.[1]?.[0], parsedJson?.[1]?.[0]?.[1]);
            let str = [];
            parsedJson?.[1]?.map((m) => {
                let w = m[1][0].replaceAll(";", ",");
                str.push(w)
            })
            str = str.join(' ');
            setTranslatedText(str)
        })
        .catch((error) => {
            console.error("Error fetching transliteration data:", error);
            setTranslatedText("");
        });
}

export { detectLanguage, translateText, updateText };

